var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "editor-wrapper" },
    [
      _c(
        "label",
        {
          class: {
            "required-field": _vm.isRequired,
            "validation-error": _vm.validationErrors.length,
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
      ),
      _vm._v(" "),
      _c("vue-editor", {
        class: { "disabled-editor": _vm.disabled },
        attrs: {
          "editor-toolbar": _vm.customToolbar,
          disabled: _vm.disabled,
          placeholder: _vm.placeholder,
        },
        on: { blur: _vm.blur },
        model: {
          value: _vm.editorContent,
          callback: function ($$v) {
            _vm.editorContent = $$v
          },
          expression: "editorContent",
        },
      }),
      _vm._v(" "),
      _vm.validationErrors.length
        ? _c(
            "div",
            { staticClass: "error-message" },
            _vm._l(_vm.validationErrors, function (messageError, idx) {
              return _c("span", { key: idx }, [
                _vm._v("\n      " + _vm._s(messageError) + "\n    "),
              ])
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }